import { Content } from "@/ui";
import SeoHead from "@/components/SeoHead";
import { blogs_helper } from "@/helpers/blogs_helper";
import styles from "./styles.module.scss";
import { csr_helper } from "@/helpers/csr_helper";
import { insights_informed_helper } from "@/helpers/insights_informed_helper copy";
import { people_helper } from "@/helpers/people_helper";
import { podcast_helper } from "@/helpers/podcast_helper";
import { event_helper } from "@/helpers/event_helper";

export default function DisruptivePage({ title, canonical, content }) {
  return (
    <div className={styles.cont}>
      <SeoHead title={title} canonical={canonical} />
      <Content items={content} />
    </div>
  );
}

export async function getStaticProps({}) {

  return {
    props: {
      title: "Disruptive",
      canonical: "/disruptive",
      content: [
        {
          component: "Hero",
          props: {
            background: {
              path: "disruptive.hero.background",
            },
          }
        },
        {
          component: "VideoSection",
          props: {
            video: "https://www.youtube.com/embed/oMbTgiyj8G4?si=wl-C1yHNNS-bkvQn&amp;controls=0",
          }
        },
        {
          component: "EventPodcastSection",
          props: {
            path: "disruptive.event",
            events: event_helper.fetch({limit: 3}),
            podcasts: podcast_helper.fetch({limit: 3}),
          }
        },
        {
          component: "WorkWithUs",
          props: {
            title: {
              path: "disruptive.banner.title"
            },
            image: {
              path: "disruptive.banner.image",
            },
            button: {
              title: 'GET TICKETS',
              href: '/'
            },
            variant: 'primary'
          }
        },
        {
          component: "MarketSection",
          props: {
            url: "https://www.youtube.com/@insightrecruitment4281"
          }
        },
        {
          component: "ReflectionSection"
        },
        {
          component: "InsightSection",
          props: {
            titlePath: "disruptive.insight_informed",
            cards: insights_informed_helper.fetch(),
          }
        },
        {
          component: "PeopleSection",
          props: {
            title: {
              path: "disruptive.people.title",
              placeholder: "PEOPLE",
            },
            url: "/why-join-us",
            videos: people_helper.fetch(),
          }
        },
        {
          component: "Csr",
          props: {
            title: {
              path: "disruptive.csr.title",
              placeholder: "CSR",
            },
            csrs: csr_helper.fetch(),
          }
        },
        {
          component: "BlogSection",
          props: {
            title: {
              path: "home.blogs.title",
              placeholder: "Check out our blog for more insights and updates",
            },
            subtitle: {
              path: "home.blogs.subtitle",
              placeholder: "Latest News",
            },
            blogs: blogs_helper.fetch(),
          }
        },
      ]
    },
  };
}
